"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
// This class originally appeared in VizPortal
var React = require("react");
var shallowEqual = require("shallowequal");
var SparklineStyles = require("./SparklineStyles");
var SparklineUtilities_1 = require("./SparklineUtilities");
/**
 * A miniature line graph of the data points given in the props. The data points will be spread
 * evenly across the x axis, and the y axis will range from 0 to the value of the largest data point
 * (all data values are assumed to be non-negative).
 */
var Sparkline = /** @class */ (function (_super) {
    __extends(Sparkline, _super);
    function Sparkline(props) {
        var _this = _super.call(this, props) || this;
        _this.normalize = new SparklineUtilities_1.Normalizer();
        _this.labelElements = {};
        _this.svgElement = null;
        _this.setSvgElement = function (element) {
            _this.svgElement = element;
        };
        _this.assignTextRef = function (fullName) { return function (element) {
            _this.labelElements[fullName] = element;
        }; };
        _this.state = _this.defaultState(props);
        return _this;
    }
    Sparkline.prototype.setStateForFullRender = function () {
        if (this.state.labeledDataPoints && this.state.labeledDataPoints.length > 0) {
            var labels = this.measureTextAndSetOffsets();
            this.setState({
                labeledDataPoints: labels,
                readyForFullRender: true
            });
        }
    };
    /*
     * Measures each text label and makes sure it will render within the confines of the SVG element.
     */
    Sparkline.prototype.measureTextAndSetOffsets = function () {
        var _this = this;
        if (!this.svgElement) {
            return [];
        }
        var offsetCorrector = new SparklineUtilities_1.OffsetCorrector(this.svgElement);
        var labels = [];
        this.state.labeledDataPoints.forEach(function (label) {
            // expects the labels to have been pushed onto the DOM by the first pass of rendering
            var textElement = _this.labelElements[label.key + 'Label'];
            if (!textElement) {
                return;
            }
            labels.push(__assign({}, label, { xOffset: offsetCorrector.correctHorizontalOffset(textElement) }));
        });
        return labels;
    };
    Sparkline.prototype.defaultState = function (props) {
        return {
            readyForFullRender: false,
            labeledDataPoints: this.getPointsToLabel(props.dataPoints),
        };
    };
    /*
     * When new props are received, the component must clear its state so that the two-pass render
     * can happen in full again.
     */
    Sparkline.prototype.componentWillReceiveProps = function (nextProps) {
        if (!shallowEqual(this.props, nextProps)) {
            this.setState(this.defaultState(nextProps));
        }
    };
    /*
     * As soon as the component has finished the first pass of the two-pass render,
     * perform the measurements and state change that will trigger the second pass.
     */
    Sparkline.prototype.componentDidMount = function () {
        this.setStateForFullRender();
    };
    Sparkline.prototype.componentDidUpdate = function () {
        if (!this.state.readyForFullRender) {
            this.setStateForFullRender();
        }
    };
    /*
     * This component renders itself in two passes. The first time, only the text labels are
     * rendered and the element is hidden. Then, on componentDidMount/compenentDidUpdate, the text
     * elements are measured, and the component computes the appropriate layout parameters to make
     * everything fits. Once this new state is set, the render happens again, this time visibly
     * rendering the entire component with the correct spacing.
     */
    Sparkline.prototype.render = function () {
        var _this = this;
        var fullRender = this.state.readyForFullRender;
        var innerWidth = this.props.width - SparklineStyles.DefaultPadding.paddingLeft
            - SparklineStyles.DefaultPadding.paddingRight;
        var innerHeight = this.props.height - SparklineStyles.DefaultPadding.paddingTop
            - SparklineStyles.DefaultPadding.paddingBottom;
        var subcomponents = [];
        if (this.props.dataPoints && this.props.dataPoints.length > 0) {
            subcomponents.push(this.svgTitle());
            this.normalize = new SparklineUtilities_1.Normalizer(this.props.dataPoints, innerWidth, innerHeight, SparklineStyles.DefaultPadding.paddingLeft, SparklineStyles.DefaultPadding.paddingTop);
            if (fullRender) {
                subcomponents.push(this.path());
            }
            this.state.labeledDataPoints.forEach(function (spec) {
                subcomponents.push(_this.labelAtDataPoint(spec)); // push to DOM for measureTextAndSetOffsets
                if (fullRender) {
                    subcomponents.push(_this.circleAtDataPoint(spec));
                }
            });
        }
        return (React.createElement("svg", { ref: this.setSvgElement, height: this.props.height, width: this.props.width, style: SparklineStyles.svgStyle, "data-tb-test-id": 'sparkline', role: 'img' }, subcomponents));
    };
    // Creates the path element using the commands from the pathBuilder
    Sparkline.prototype.path = function () {
        var pathBuilder = new SparklineUtilities_1.PathBuilder(this.normalize);
        return (React.createElement("path", { key: 'path', stroke: SparklineStyles.LineColor, strokeWidth: SparklineStyles.LineWidth, fill: 'none', d: pathBuilder.buildPath(this.props.dataPoints) }));
    };
    Sparkline.prototype.svgTitle = function () {
        return React.createElement("title", null, this.props.title);
    };
    // Creates the circle element to be placed along the path
    Sparkline.prototype.circleAtDataPoint = function (spec) {
        var fullName = spec.key + 'Circle';
        return (React.createElement("circle", __assign({ key: fullName, "data-tb-test-id": fullName, cx: this.normalize.x(spec.index), cy: this.normalize.y(this.props.dataPoints[spec.index]) }, spec.circleStyle)));
    };
    /*
     * Returns the label element at data point i, with the data point's value as the circle text.
     * If circleStyle is passed in, it is assumed that a circle exists on that data point with the given style.
     * labelPosition denotes the vertical position of the label with respect to the data point:
     *   'above' for above the point, 'below' for below the point.
     */
    Sparkline.prototype.labelAtDataPoint = function (spec) {
        var labelValue = this.props.dataPoints[spec.index];
        var fullName = spec.key + 'Label';
        var textBuffer = spec.circleStyle.r + spec.circleStyle.strokeWidth + SparklineStyles.TextBuffer;
        var yOffset = (spec.labelPosition === 'above') ? -textBuffer : textBuffer + SparklineStyles.LabelStyle.fontSize - 1.5;
        return (React.createElement("text", { ref: this.assignTextRef(fullName), key: fullName, "data-tb-test-id": fullName, style: this.state.readyForFullRender
                ? __assign({}, SparklineStyles.LabelStyle, { visibility: 'visible' }) : __assign({}, SparklineStyles.LabelStyle, { visibility: 'hidden' }), x: this.normalize.x(spec.index), y: this.normalize.y(labelValue), dx: spec.xOffset, dy: yOffset, textAnchor: 'middle' }, labelValue));
    };
    // puts labels on the endpoint, the max, and the min
    Sparkline.prototype.getPointsToLabel = function (dataPoints) {
        var labelPoints = [];
        if (!dataPoints || dataPoints.length === 0) {
            return labelPoints;
        }
        var minIndex = dataPoints.indexOf(Math.min.apply(Math, dataPoints));
        var maxIndex = dataPoints.indexOf(Math.max.apply(Math, dataPoints));
        var endIndex = dataPoints.length - 1;
        var endPointHigher = dataPoints[endIndex] >= dataPoints[endIndex - 1];
        // pushing the circle styling onto the endpoint
        labelPoints.push({
            key: 'end',
            index: endIndex,
            circleStyle: SparklineStyles.CircleStyleEnd,
            labelPosition: (endPointHigher ? 'above' : 'below')
        });
        // pushing the circle styling onto the maxpoint (assuming it's not the endpoint)
        if (endIndex !== maxIndex) {
            labelPoints.push({
                key: 'max',
                index: maxIndex,
                circleStyle: SparklineStyles.CircleStyleMax,
                labelPosition: 'above'
            });
        }
        // pushing the circle styling onto the minpoint (assuming it's not the end or the max)
        if (endIndex !== minIndex && maxIndex !== minIndex) {
            labelPoints.push({
                key: 'min',
                index: minIndex,
                circleStyle: SparklineStyles.CircleStyleMin,
                labelPosition: 'below'
            });
        }
        return labelPoints;
    };
    return Sparkline;
}(React.Component));
exports.Sparkline = Sparkline;
//# sourceMappingURL=Sparkline.js.map